import getSymbolsInPatternWithPosition from '../getSymbolsInPatternWithPosition/getSymbolsInPatternWithPosition.mjs';

const getCountOfSymbolsInSelection = (selectionStart, selectionEnd, pattern) => getSymbolsInPatternWithPosition(pattern).filter(symbol => symbol.index >= selectionStart && symbol.index < selectionEnd).length;

export { getCountOfSymbolsInSelection as default };
//# sourceMappingURL=getCountOfSymbolsInSelection.mjs.map
